module.exports = __webpack_public_path__ + "static/media/fabrika-lukavec-de-bondt-50.d1e0b359.jpg";